import { useState } from "react"
import { useHistory, useParams } from "react-router"
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material"
import { Box, Button } from "@mui/material"
import { CustomDialog } from "../../components"
import { useStyles } from './style'
import one from '../../assets/Images/stepper/1.svg'
import two from '../../assets/Images/stepper/2.svg'
import three from '../../assets/Images/stepper/3.svg'
import four from '../../assets/Images/stepper/4.svg'
import five from '../../assets/Images/stepper/5.svg'
import six from '../../assets/Images/stepper/6.svg'
import stepper1 from '../../assets/Images/stepper/stepper1.svg'
import stepper2 from '../../assets/Images/stepper/stepper2.svg'
import stepper3 from '../../assets/Images/stepper/stepper3.svg'
import stepper4 from '../../assets/Images/stepper/stepper4.svg'
import stepper5 from '../../assets/Images/stepper/stepper5.svg'
import stepper6 from '../../assets/Images/stepper/stepper6.svg'
import psegstepper1 from '../../assets/Images/stepper/pseg/stepper1.svg'
import psegstepper2 from '../../assets/Images/stepper/pseg/stepper2.svg'
import psegstepper3 from '../../assets/Images/stepper/pseg/stepper3.svg'
import psegstepper4 from '../../assets/Images/stepper/pseg/stepper4.svg'
import psegstepper5 from '../../assets/Images/stepper/pseg/stepper5.svg'
import ctessstepper1 from '../../assets/Images/stepper/ctess/stepper1.svg'
import ctessstepper2 from '../../assets/Images/stepper/ctess/stepper2.svg'
import ctessstepper3 from '../../assets/Images/stepper/ctess/stepper3.svg'
import ctessstepper4 from '../../assets/Images/stepper/ctess/stepper4.svg'
import ctessstepper5 from '../../assets/Images/stepper/ctess/stepper5.svg'
import { FAMILY_KEY, PROGRAM_KEY } from "../../constants/common"
import { ENROLLMENT_FORMS, PROGRAMDETAILS_FILES, TANDC_FORMS } from "../../constants/files"

const Process = (props) => {
  const classes = useStyles()
  const history = useHistory()
  const [activeStep, setActiveStep] = useState(0)
  const { programId } = useParams()
  const steps = {
    [PROGRAM_KEY.APS_RBP]: [
      {
        header: <>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <img src={one} className={classes.stepperNumberImg} alt="" />
          </Box>
          <Box display="flex" justifyContent="center" flexGrow="1">
            <img src={stepper1} className={classes.stepperImg} alt="" />
          </Box>
        </>,
        description: <>
          <Box sx={{ mx: { xs: 0, sm: 7 } }}>{`Download EnergyHub and Enphase Terms and conditions document and get it signed by homeowner`}</Box>
          <Box className={classes.stepperLink} onClick={() => props.getFiles()}>Download T&C Document here</Box>
        </>,
      },
      {
        header: <>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <img src={two} className={classes.stepperNumberImg} alt="" />
          </Box>
          <Box display="flex" justifyContent="center" flexGrow="1">
            <img src={stepper2} className={classes.stepperImg} alt="" />
          </Box>
        </>,
        description:
          <Box sx={{ mx: { xs: 0, sm: 8 } }}>Fill homeowner details, upload signed T&C document and submit the application{' '}
            <Box component="span" className={classes.stepperLink} onClick={() => history.push(`/applications/application-form?${props.urlProgram}`)}>here</Box>{' '}
            for APS review
          </Box>,
      },
      {
        header: <>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <img src={three} className={classes.stepperNumberImg} alt="" />
          </Box>
          <Box display="flex" justifyContent="center" flexGrow="1">
            <img src={stepper3} className={classes.stepperImg} alt="" />
          </Box>
        </>,
        description: <Box sx={{ mx: { xs: 0, sm: 9 } }}>Submitted Application now goes to APS for approval or rejection via EnergyHub</Box>,
      },
      {
        header: <>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <img src={four} className={classes.stepperNumberImg} alt="" />
          </Box>
          <Box display="flex" justifyContent="center" flexGrow="1">
            <img src={stepper4} className={classes.stepperImg} alt="" />
          </Box>
        </>,
        description: <>
          <Box sx={{ mx: { xs: 0, sm: 3 } }}>Once approved by APS, complete the site commissioning. Site goes live with a unique Enphase Site ID. Provide Enphase Site ID via Intake Portal for Enphase to map the application.</Box>
          <Box><a href="https://support.enphase.com/s/article/Where-do-I-find-my-system-Site-ID" className={classes.stepperLink} target="_blank" rel="noopener noreferrer">Where to find Enphase Site ID?</a></Box>
        </>
      },
      {
        header: <>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <img src={five} className={classes.stepperNumberImg} alt="" />
          </Box>
          <Box display="flex" justifyContent="center" flexGrow="1">
            <img src={stepper5} className={classes.stepperImg} alt="" />
          </Box>
        </>,
        description: <Box sx={{ mx: { xs: 0, sm: 8 } }}>The Application is now submitted for Enphase Review</Box>,
      },
      {
        header: <>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <img src={six} className={classes.stepperNumberImg} alt="" />
          </Box>
          <Box display="flex" justifyContent="center" flexGrow="1">
            <img src={stepper6} className={classes.stepperImg} alt="" />
          </Box>
        </>,
        description: <>
          <Box sx={{ mx: { xs: 0, sm: 8 } }}>Good Job! Once approved by Enphase, you’ve got the site successfully enrolled in the program.</Box>
          <Box className={classes.secondaryText} mt={2}>APS can now schedule events for the site</Box>
        </>,
      },
    ],
    [PROGRAM_KEY.PSEG_LI]: [
      {
        header: <>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <img src={one} className={classes.stepperNumberImg} alt="" />
          </Box>
          <Box display="flex" justifyContent="center" flexGrow="1">
            <img src={psegstepper1} className={classes.stepperImg} alt="" />
          </Box>
        </>,
        description: <>
          <Box sx={{ mx: { xs: 0, sm: 0 } }}>{`Download`} <Box component="span" className={classes.stepperLink} onClick={() => props.getFiles(TANDC_FORMS)}>{`Enphase T&C Document`}</Box> and <Box component="span" className={classes.stepperLink} onClick={() => props.getFiles(PROGRAMDETAILS_FILES)}>{`NYSERDA Customer Attestation Form.`}</Box></Box>
          <Box sx={{ mx: { xs: 0, sm: 0 } }}>{`Get these forms signed from homeowner and upload on PSEG Portal.`}</Box>
        </>,
      },
      {
        header: <>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <img src={two} className={classes.stepperNumberImg} alt="" />
          </Box>
          <Box display="flex" justifyContent="center" flexGrow="1">
            <img src={psegstepper2} className={classes.stepperImg} alt="" />
          </Box>
        </>,
        description: <>
          <Box sx={{ mx: { xs: 0, sm: 10 } }}>{`Once site installation is completed, download and populate `}
            <Box component="span" className={classes.stepperLink} onClick={() => props.getFiles(ENROLLMENT_FORMS)}>{`PSEG Enrolment form.`}</Box>
          </Box>
        </>,
      },
      {
        header: <>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <img src={three} className={classes.stepperNumberImg} alt="" />
          </Box>
          <Box display="flex" justifyContent="center" flexGrow="1">
            <img src={psegstepper3} className={classes.stepperImg} alt="" />
          </Box>
        </>,
        description: <>
          <Box sx={{ mx: { xs: 0, sm: 4 } }}>{`Fill homeowner details, upload all three documents (PSEG Enrolment Form, Enphase T&C and NYSERDA Customer Attestation Form) and submit the application `}
            <Box component="span" className={classes.stepperLink} onClick={() => history.push(`/applications/application-form?${props.urlProgram}`)}>here</Box>{` for Enphase review.`}
          </Box>
        </>,
      },
      {
        header: <>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <img src={four} className={classes.stepperNumberImg} alt="" />
          </Box>
          <Box display="flex" justifyContent="center" flexGrow="1">
            <img src={psegstepper4} className={classes.stepperImg} alt="" />
          </Box>
        </>,
        description: <>
          <Box sx={{ mx: { xs: 0, sm: 7 } }}>{`Enphase reviews the application and provides its approval.`}</Box>
          <Box sx={{ mx: { xs: 0, sm: 7 } }}>{`On Enphase approval, the application is submitted for PSEG review.`}</Box>
        </>
      },
      {
        header: <>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <img src={five} className={classes.stepperNumberImg} alt="" />
          </Box>
          <Box display="flex" justifyContent="center" flexGrow="1">
            <img src={psegstepper5} className={classes.stepperImg} alt="" />
          </Box>
        </>,
        description: <>
          <Box sx={{ mx: { xs: 0, sm: 10 } }}>Good Job! Once approved by PSEG, you’ve got the site successfully enrolled in the program.</Box>
          <Box sx={{ mx: { xs: 0, sm: 8 }, mt: 3, fontSize: '14px' }}>Events can now be scheduled for the live site.</Box>
        </>,
      },
    ],
    [props.isFamilyKey ? FAMILY_KEY.CT_ESS : PROGRAM_KEY.CT_ESS]: [
      {
        header: <>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <img src={one} className={classes.stepperNumberImg} alt="" />
          </Box>
          <Box display="flex" justifyContent="center" flexGrow="1">
            <img src={ctessstepper1} className={classes.stepperImg} alt="" />
          </Box>
        </>,
        description: <>
          <Box sx={{ mx: { xs: 0, sm: 0 } }}>{`Download`} <Box component="span" className={classes.stepperLink} onClick={() => props.getFiles(TANDC_FORMS)}>{`Enphase T&C Document`}</Box> , get it signed by </Box>
          <Box sx={{ mx: { xs: 0, sm: 0 } }}>{`homeowner and upload on CT Green Bank Portal.`}</Box>
        </>,
      },
      {
        header: <>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <img src={two} className={classes.stepperNumberImg} alt="" />
          </Box>
          <Box display="flex" justifyContent="center" flexGrow="1">
            <img src={ctessstepper2} className={classes.stepperImg} alt="" />
          </Box>
        </>,
        description: <>
          <Box sx={{ mx: { xs: 0, sm: 10 } }}>{`Once site commissioning is completed, visit CTGB Portal`}</Box>
          <Box>{`and upload PTO document from utility.`}</Box>
        </>,
      },
      {
        header: <>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <img src={three} className={classes.stepperNumberImg} alt="" />
          </Box>
          <Box display="flex" justifyContent="center" flexGrow="1">
            <img src={ctessstepper3} className={classes.stepperImg} alt="" />
          </Box>
        </>,
        description: <>
          <Box sx={{ mx: { xs: 0, sm: 11 } }}>{`Fill homeowner details, upload Enphase T&C and Reservation of Funds documents and submit the application `}
            <Box component="span" className={classes.stepperLink} onClick={() => history.push(`/applications/application-form?${props.urlProgram}`)}>here</Box>
            <Box>{` for Enphase review.`}</Box>
          </Box>
        </>,
      },
      {
        header: <>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <img src={four} className={classes.stepperNumberImg} alt="" />
          </Box>
          <Box display="flex" justifyContent="center" flexGrow="1">
            <img src={ctessstepper4} className={classes.stepperImg} alt="" />
          </Box>
        </>,
        description: <>
          <Box sx={{ mx: { xs: 0, sm: 7 } }}>{`Enphase reviews the application and provides its approval.`}</Box>
          <Box sx={{ mx: { xs: 0, sm: 7 } }}>{`On Enphase approval, the application is submitted for Utility review.`}</Box>
        </>
      },
      {
        header: <>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <img src={five} className={classes.stepperNumberImg} alt="" />
          </Box>
          <Box display="flex" justifyContent="center" flexGrow="1">
            <img src={ctessstepper5} className={classes.stepperImg} alt="" />
          </Box>
        </>,
        description: <>
          <Box sx={{ mx: { xs: 0, sm: 10 } }}>Good Job! Once approved by Utility, you’ve got the site successfully enrolled in the program.</Box>
          <Box className={classes.noticeText} sx={{ mx: { xs: 0, sm: 8 }, mt: 3, fontSize: '14px' }}>Events can now be scheduled for the live site.</Box>
        </>,
      },
    ],
    [PROGRAM_KEY.GMP_BYOD]: [
      {
        header: <>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <img src={one} className={classes.stepperNumberImg} alt="" />
          </Box>
          <Box display="flex" justifyContent="center" flexGrow="1">
            <img src={psegstepper3} className={classes.stepperImg} alt="" />
          </Box>
        </>,
        description: <>
          <Box sx={{ mx: { xs: 0, sm: 4 } }}>{`Fill homeowner details, upload signed documents and submit the application `}
            <Box component="span" className={classes.stepperLink} onClick={() => history.push(`/applications/application-form?${props.urlProgram}`)}>here</Box>{` for Enphase review.`}
          </Box>
        </>,
      },
      {
        header: <>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <img src={two} className={classes.stepperNumberImg} alt="" />
          </Box>
          <Box display="flex" justifyContent="center" flexGrow="1">
            <img src={psegstepper5} className={classes.stepperImg} alt="" />
          </Box>
        </>,
        description: <>
          <Box sx={{ mx: { xs: 0, sm: 10 } }}>Good Job! Once approved by Enphase, you’ve got the site successfully enrolled in the program. </Box>
          <Box sx={{ mx: { xs: 0, sm: 8 }, mt: 3, fontSize: '14px' }}>Events can now be scheduled for the live site.</Box>
        </>,
      },
    ],
  }
  const maxSteps = props.programKey && steps[props.programKey] ? steps[props.programKey].length : 0

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1)
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1)
  }

  const getProcessFlow = () => {
    return (
      <Box>
        <Box sx={{ height: { xs: '355px', md: '330px' } }}>
          <Box display="flex">
            {steps[props.programKey][activeStep].header}
          </Box>
          <Box className={classes.stepperContent} sx={{ p: 2, mt: 2 }}>
            {steps[props.programKey][activeStep].description}
          </Box>
        </Box>
        <Box display="flex" justifyContent="space-between" p={1}>
          <Button size="small" onClick={handleBack} disabled={activeStep === 0} sx={{ visibility: activeStep === 0 ? 'hidden' : '', color: '#000000', fontWeight: 'bold' }}>
            <KeyboardArrowLeft />
            BACK
          </Button>
          <Box display="flex" alignItems="center">
            {steps[props.programKey].map((step, index) => (
              <Box key={index} color="primary" className={`${activeStep === index ? classes.customDotActive : classes.customDot}`} onClick={() => setActiveStep(index)} />
            ))}
          </Box>
          <Button
            size="small"
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
            sx={{ visibility: activeStep === maxSteps - 1 ? 'hidden' : '', color: '#000000', fontWeight: 'bold' }}
          >
            NEXT
            <KeyboardArrowRight />
          </Button>
        </Box>
      </Box>
    )
  }

  const getNoProgramKeyContent = () => {
    return (
      <Box display="flex" justifyContent="center" alignItems="center">
        <Box fontWeight="bold">No process flow steps found. Please select a valid program.</Box>
      </Box>
    )
  }

  return (
    <CustomDialog fullWidth classes={{ paper: props.programKey !== PROGRAM_KEY.APS_RBP ? classes.customPaper : '' }} maxWidth={props.programKey !== PROGRAM_KEY.APS_RBP ? '' : 'sm'} open={props.open} title="" content={props.programKey && steps[props.programKey] ? getProcessFlow() : getNoProgramKeyContent()} handleClose={props.handleClose} scroll="paper" />
  )
}

export default Process